<template>
  <div id="report">
    <div class="report-date-filter text-end">
      <span class="me-3">คัดกรองจากวันที่</span>
      <el-date-picker
        v-model="defaultReportDate"
        :default-time="['00:00:00', '23:59:59']"
        format="dd-MM-yyyy HH:mm"
        start-placeholder="เริ่ม"
        end-placeholder="สิ้นสุด"
        range-separator="ถึง"
        type="datetimerange"
      ></el-date-picker>
    </div>
    <div class="report-container">
      <div class="row header">
        <div class="col-5">ชื่อรายงาน</div>
        <div class="col-4">ตัวเลือก</div>
        <div class="col-3">แอคชั่น</div>
      </div>
      <div class="row-wrapper">
        <report-list-cell
          v-for="(report, i) in visibleReportList"
          :key="i + 1"
          v-model="reportSelectedValues[report.valueKey]"
          :title="report.name"
          :options="report.option"
          :param-key="report.key"
          :download-endpoint="report.url"
          :filter-date="defaultReportDate"
        ></report-list-cell>
      </div>
    </div>
  </div>
</template>

<script>
import * as R from "ramda"
import moment from "moment"
import { DatePicker } from "element-ui"
import ListCell from "@/components/admin/view/report/ListCell"
import { baanRueJaiClient } from "@/dependencies"

export default {
  components: {
    "el-date-picker": DatePicker,
    "report-list-cell": ListCell,
  },
  props: {
    filterDate: {
      type: null,
      default: undefined,
    },
  },
  data() {
    const projects = []

    const defaultReportDate = [
      moment().startOf("day").subtract(30, "days"),
      moment().endOf("day"),
    ]
    const reportSelectedValues = {
      activity: "IMMEDIATE",
      privilege: "IMMEDIATE",
      homecare: null,
    }

    return {
      projects,
      defaultReportDate,
      reportSelectedValues,
    }
  },
  computed: {
    visibleReportList() {
      return this.reportList.filter(({ isHidden }) => !isHidden)
    },
    reportList() {
      return [
        {
          name: "Activity - กิจกรรม",
          url: "/admin/reports/activities",
          option: this.options.ARTICLE,
          key: "type",
          valueKey: "activity",
          isHidden: this.$isCallCenter,
        },
        {
          name: "Privilege - สิทธิพิเศษ",
          url: "/admin/reports/privileges",
          option: this.options.ARTICLE,
          key: "type",
          valueKey: "privilege",
          isHidden: this.$isCallCenter,
        },
        {
          name: "Conversation - จำนวนกระทู้ข้อความตามประเภท",
          url: "/admin/reports/conversations",
        },
        {
          name: "Conversation Reply Rate - อัตราการตอบกลับข้อความ",
          url: "/admin/reports/conversationReplies",
        },
        {
          name: "Home Care - จำนวนการเปิดจ๊อบตามกลุ่มโครงการ",
          url: "/admin/reports/homecares",
          option: this.options.PROJECT,
          key: "project_ids",
          valueKey: "homecare",
          isHidden: this.$isCallCenter,
        },
        {
          name: "User Registration - จำนวนผู้ใช้งานในระบบ",
          url: "/admin/reports/userRegisters",
          isHidden: this.$isCallCenter,
        },
        {
          name: "Admin Activity - สถิติการใช้งานหลังบ้าน",
          url: "/admin/reports/adminActiveHistories",
          isHidden: this.$isCallCenter,
        },
        {
          name: "Article Name - ข้อมูลข่าวพร้อมไอดี ทุกประเภท",
          url: "/admin/reports/createdArticles",
          isHidden: this.$isCallCenter,
        },
      ]
    },
    options() {
      return {
        ARTICLE: this.articleOption,
        PROJECT: this.projectOption,
      }
    },
    articleOption() {
      return [
        {
          label: "ประเภท",
          options: [
            { label: "รับสิทธิ์ทันที", value: "IMMEDIATE" },
            { label: "ลงทะเบียนรับสิทธิ์", value: "REGISTER" },
          ],
        },
      ]
    },
    projectOption() {
      const labels = {
        H: "กลุ่มโครงการแนวสูง",
        L: "กลุ่มโครงการแนวราบ",
      }

      return R.pipe(
        R.groupBy(R.prop("projectType")),
        R.mapObjIndexed(
          R.pipe(
            R.groupBy(R.prop("projectGroup")),
            R.mapObjIndexed((projects, label) => ({
              label,
              value: R.map(R.prop("projectId"))(projects).toString(),
            })),
            R.values,
          ),
        ),
        R.toPairs,
        R.map(([key, options]) => ({ label: labels[key], options })),
      )(this.projects)
    },
  },
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      await this.setupProjects()
    },
    async setupProjects() {
      const projects = await this.fetchProjects()

      this.projects = projects
    },
    async fetchProjects() {
      const response = await baanRueJaiClient.admin.projects.list()

      return response.data
    },
  },
}
</script>

<style lang="scss" scoped>
#report {
  height: calc(100% - 110px);
}

.report-date-filter {
  border-top: 1px solid #e0e0e0;
  padding: 16px;
  color: $warm-grey;
  font-size: 16px;
}

.report-container {
  background: $white;
  font-size: 15px;
  height: calc(100% - 73px);
  overflow: auto;

  .row {
    margin: 0;

    & > div {
      border-right: 1px solid #e0e0e0;
      padding: 12px 32px;
    }
  }

  .header {
    font-weight: 600;
    text-align: center;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    color: $black;

    & > div {
      padding: 18px 0;
    }
  }

  .row-wrapper {
    height: calc(100% - 60px);
  }
}
</style>
